// extracted by mini-css-extract-plugin
export var active = "locking-scroll-module--active--87fc5";
export var description = "locking-scroll-module--description--931d9";
export var descriptionContainer = "locking-scroll-module--descriptionContainer--5897a";
export var descriptionText = "locking-scroll-module--descriptionText--fb850";
export var image = "locking-scroll-module--image--8fc70";
export var moduleContainer = "locking-scroll-module--moduleContainer--46924";
export var parent = "locking-scroll-module--parent--c85ef";
export var step = "locking-scroll-module--step--d64d3";
export var stepContainer = "locking-scroll-module--stepContainer--b325e";
export var stepName = "locking-scroll-module--stepName--21a30";
export var stepsContainer = "locking-scroll-module--stepsContainer--0d457";
export var stepsContainerInner = "locking-scroll-module--stepsContainerInner--c349c";
export var toc = "locking-scroll-module--toc--1e357";
export var tocItem = "locking-scroll-module--tocItem--95f50";